import { render } from "./Update.vue?vue&type=template&id=0ff2543f&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Update.vue?vue&type=style&index=1&id=0ff2543f&scoped=true&lang=css"

import exportComponent from "/Users/hank/winho/gx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff2543f"]])

export default __exports__